<template>
  <div>
    <div v-if="success !== null" class="container pt-0">
      <div class="row">
        <div class="col text-center">
          <h1 class="fs-40">{{ $t("heading_confirmed") }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="pane">
            <div class="row">
              <div
                v-if="proposal"
                class="col-md-5 pr-lg-5 text-left order-2 order-md-1"
                :class="{ 'border-right': !isMobile }"
              >
                <h2>{{ $t("your_appointment") }}</h2>
                <termin-zusammenfassung />
              </div>
              <div class="col order-1 order-md-2 mb-5 mb-md-0">
                <div class="text-center">
                  <div
                    class="fs-40 mt-5 text-primary"
                  >
                    <font-awesome-icon
                      v-if="success"
                      :icon="success ? 'check' : 'times'"
                    />
                  </div>
                  <div
                    ref="textConfirm"
                    class="text-confirm-head mt-3 text-primary"
                  >
                    {{
                      this.success
                        ? $t("termin_gebucht")
                        : $t("termin_nicht_gebucht")
                    }}
                  </div>
                  <div v-if="success" class="mt-5">
                    <button class="btn btn-primary" @click="downloadIcs()">
                      Termin im Kalender speichern
                    </button>
                  </div>
                  <div v-if="!success" class="row mt-5">
                    <div class="col-md-8 offset-md-2">
                      <p
                        class="text-confirm text-center"
                        v-html="$t('error.terminbestaetigung_fehler')"
                      />
                    </div>
                  </div>
                </div>

                <div v-if="anzahlungNoetig && terminart.otp" class="mt-4 row">
                  <div class="col-12">
                    <div class="pane text-dark">
                      <div class="row">
                        <div class="col-12 text-center">
                          <div
                            class="font-weight-bold fs-24"
                            style="line-height: 1"
                          >
                            {{ $t("anzahlung.anzahlung_label") }}
                          </div>
                          <div class="mt-2">
                            {{ $t("anzahlung.anzahlung_hinweis") }}
                          </div>
                          <div class="text-confirm-head mb-2 text-primary">
                            {{ anzahlung | formatPrice }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="col text-center"
                          v-for="qr in qr_data"
                          :key="qr.id"
                        >
                          <div class="mb-3">
                            <b>{{ qr.data.creditor.name }}</b
                            ><br />
                            {{ $t("anzahlung.iban") }} {{ qr.data.creditor.iban
                            }}<br />
                            {{ $t("anzahlung.bic") }} {{ qr.data.creditor.bic
                            }}<br />
                            {{ $t("anzahlung.verwendungszweck") }}
                            {{ vorgangsnummer }}
                            <template v-if="reference && qr.type === 'swiss'">
                              <br />
                              {{ $t("anzahlung.referenz") }}
                              {{ reference }}<!-- {{ getPruefziffer(reference) }} --> <!-- Prüfziffer ist bereits an der API-Response enthalten, daher hier nicht nochmal berechnen -->
                            </template>
                          </div>
                          <swiss-qr-code
                            v-if="qr.type === 'swiss'"
                            :data="qr.data"
                            :width="130"
                          />
                          <!--<epc-qr-code
                            v-if="qr.type === 'epc'"
                            :data="qr.data"
                            :width="130"
                          />-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import Start from "@/components/Start.vue";

import TerminZusammenfassung from "@/components/TerminZusammenfassung";
import { createEvent } from "ics";
import FileSaver from "file-saver";
import { DateTime } from "luxon";
import SwissQrCode from "../components/SwissQrCode.vue";
//import EpcQrCode from "../components/EpcQrCode.vue";
import cliniusKonten from "../static/konten.clinius";
import cliniusChKonten from "../static/konten.cliniusCh";

export default {
  name: "TerminbestaetigungComponent",
  components: {
    TerminZusammenfassung,
    SwissQrCode,
    //EpcQrCode,
  },
  data() {
    return {
      token: this.$route.query.token,
      success: null,
    };
  },
  async created() {
    if (this.token)
      this.success = await this.$store.dispatch("confirmTermin", [this.token]);
    else this.success = true;
  },
  computed: {
    proposal() {
      return this.$store.state.termin.selectedTermin;
    },
    terminart() {
      return this.$store.state.termin.behandlung;
    },
    praxis() {
      //if (typeof this.$store.state.termin.praxis === "string")
        return this.$store.state.praxen.find(
          (p) => p.value === this.$store.state.termin.praxis
        );
      //else return this.$store.state.termin.praxis;
    },
    anzahlungNoetig() {
      return this.anzahlung > 0;
    },
    anzahlung() {
      return this.$store.state.anzahlung || 0;
    },
    reference() {
      return this.$store.state.reference || null;
    },
    vorgangsnummer() {
      return `AZ ${this.$store.state.vorgangsnummer}`;
    },
    konten() {
        if (
          process.env.VUE_APP_CLINIUS_CH &&
          process.env.VUE_APP_CLINIUS_CH === "1"
        ) {
          return cliniusChKonten;
        } else {
          return cliniusKonten;
        }
    },

    qr_data() {
      return this.konten.map((k, i) => {
        return {
          id: i,
          type: k.type,
          data: {
            currency: k.waehrung,
            amount: this.anzahlung,
            reference: this.reference,
            message: `Anzahlung ${this.vorgangsnummer}`,
            creditor: {
              name: k.empfaenger,
              addresse: k.adresse,
              hausnr: k.hausnr,
              plz: k.plz,
              ort: k.ort,
              country: k.land,
              iban: k.iban,
              bic: k.bic,
            },
          },
        };
      });
    },
  },
  mounted() {
    if (this.isMobile) {
      const el = this.$refs.textConfirm;
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    this.$nextTick(function () {
      window.gtag("js", new Date());
      window.gtag("config", "AW-946345942");
    });
  },
  filters: {
    formatPrice(val) {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(val);
    },
  },
  methods: {
    downloadIcs() {
      let startDate = DateTime.fromISO(this.proposal.start);

      // eslint-disable-next-line no-unused-vars
      const event = {
        start: [
          startDate.year,
          startDate.month,
          startDate.day,
          startDate.hour,
          startDate.minute,
        ],
        duration: {
          hours: Math.floor(this.terminart.dauer / 60),
          minutes: this.terminart.dauer % 60,
        },
        title: process.env.VUE_APP_CLINIUS_CH === "1"
          ? "Termin H1-Zahnärzte"
          : "Termin CLINIUS+ Zahnärzte",
        description: "",
        //location: this.praxis.address?.replaceAll("\n", ", "),
        location: (this.praxis && this.praxis.address) ? this.praxis.address.replaceAll("\n", ", ") : "",
        status: "CONFIRMED",
      };

      if (!this.isAndroid) {
        event.alarms = [
          {
            action: "display",
            trigger: {
              hours: 1,
              minutes: 30,
              before: true,
            },
          },
        ];
      }

      // eslint-disable-next-line no-undef
      createEvent(event, (error, value) => {
        if (error) {
          alert(error);
        } else {
          var blob = new Blob([value], { type: "text/calendar;charset=utf-8" });
          FileSaver.saveAs(blob, "appointment.ics");
        }
      });
    },
    getPruefziffer(referenz) {
      var tabelle = [0, 9, 4, 6, 8, 2, 7, 1, 3, 5];
      var uebertrag = 0;

      for (let i = 0; i < referenz.length; i++) {
        uebertrag =
          tabelle[
            (uebertrag + referenz.charAt(i).charCodeAt() - "0".charCodeAt()) %
              10
          ];
      }

      return ((10 - uebertrag) % 10).toString();
    },
  },
};
</script>
